<h2 class="text-xl font-bold">
  Edelmetallkurs bearbeiten
</h2>

<form class="w-full" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-col w-full">
    <div class="flex flex-col mt-2">
      <label class="soft-label top required">Menge</label>
      <soft-input formControlName="begriff" [readonly]="true"></soft-input>
    </div>
    <div class="flex flex-col mt-2">
      <label class="soft-label top required">Kurs</label>
      <soft-number-input formControlName="betrag"></soft-number-input>
    </div>
    <div class="flex flex-col mt-2">
      <label class="soft-label top required">Verarbeitungsverlust (Prozent)</label>
      <div class="flex gap-2 w-full items-center">
        <soft-number-input formControlName="verarbeitungsverlust" class="w-full"></soft-number-input>
        <span class="text-right font-semibold">%</span>
      </div>
    </div>
  </div>

  <button type="submit"
          class="soft-button primary w-full h-12 mt-4"
          [disabled]="form.invalid">
    Speichern
  </button>
</form>
